import React from "react";

import * as S from "./styles";

import IProps from "./props";

const Paginator: React.FC<IProps> = ({ currentStep }) => {
  const steps = [1, 2, 3, 4];

  return (
    <S.Container>
      {steps.map((step, index) => (
        <React.Fragment key={step}>
          <S.Pass active={currentStep === step} isComplete={currentStep > step}>
            {step}
          </S.Pass>
          {index < steps.length - 1 && (
            <S.Dash isComplete={currentStep > step} />
          )}
        </React.Fragment>
      ))}
    </S.Container>
  );
};

export default Paginator;
